"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = exports.StyledLinkMainBox = exports.StyledIconMainBox = exports.StyledNewtonMenuMain = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledNewtonMenuMain = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledNewtonMenuMain",
  componentId: "sc-1ltv99n-0"
})(["position:fixed;padding-top:28px;height:calc(100vh - 76px - 56px);width:160px;z-index:2;.navlink-selected{color:", ";font-weight:bold;}", ""], function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.isDesktopSmall && (0, _styledComponents.css)(["width:208px;"]);
});

exports.StyledNewtonMenuMain = StyledNewtonMenuMain;
var StyledIconMainBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledIconMainBox",
  componentId: "sc-1ltv99n-1"
})(["margin-left:48px;margin-bottom:16px;svg{cursor:pointer;transition:opacity 300ms ease;rect{fill:", ";stroke:", ";}line{stroke:", ";}path{stroke:", ";}&:hover{rect{stroke:", ";}line{stroke:", ";}path{stroke:", ";}}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
});
exports.StyledIconMainBox = StyledIconMainBox;
var StyledLinkMainBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledLinkMainBox",
  componentId: "sc-1ltv99n-2"
})(["padding-left:48px;padding-top:40px;height:calc(100% - 40px);background:", ";opacity:0;-webkit-transform:translate3d(-260px,0,0);-ms-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0);transition:transform 500ms ease,opacity 500ms ease;overflow-y:scroll;&::-webkit-scrollbar{display:none;}", " > div{& + div{margin-top:16px;}}"], function (props) {
  return props.appearance === 'DARK' ? 'rgba(28,28,28,0.8)' : 'rgba(255, 255, 255, 0.8)';
}, function (props) {
  return props.show && (0, _styledComponents.css)(["opacity:1;-webkit-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0);"]);
});
exports.StyledLinkMainBox = StyledLinkMainBox;

var StyledDivider = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledDivider",
  componentId: "sc-1ltv99n-3"
})(["width:64px;height:1px;margin:48px 0 !important;border:1px solid ", ";"], function (props) {
  return props.theme[props.fontColor];
});

exports.StyledDivider = StyledDivider;